module.exports = __webpack_public_path__ + "img/ivan-belikov-parus.a6f61ea.jpg";